import { render, staticRenderFns } from "./SeriesPreview.vue?vue&type=template&id=5dd91ff0&scoped=true&"
import script from "./SeriesPreview.vue?vue&type=script&lang=js&"
export * from "./SeriesPreview.vue?vue&type=script&lang=js&"
import style0 from "./SeriesPreview.vue?vue&type=style&index=0&id=5dd91ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd91ff0",
  null
  
)

export default component.exports